// @docs https://[domain]/api/v1/docs
export default {
  List: "/group-employees",
  Detail: "/group-employees",
  Update: "/group-employees",
  Create: "/group-employees",
  Delete: "/group-employees",
  ListShort: "/group-employees/short",

  ListEmployee: "/group-employee/employees",
  AddEmployee: "/group-employee/add-employees",
  RemoveEmployee: "/group-employee/remove-employees",

  ListRole: "/group-employee/roles",
  AddRole: "/group-employee/add-roles",
  RemoveRole: "/group-employee/remove-roles",
};
